import { Component, Input } from '@angular/core';
import { ClrDatagridModule, ClrIconModule, ClrTabsModule } from "@clr/angular";
import { TranslocoDirective } from "@jsverse/transloco";

import { ClarityIcons, exclamationCircleIcon, exclamationTriangleIcon } from "@cds/core/icon";
import { CommentOverviewComponent } from "../comment-overview/comment-overview.component";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-comment-project-card',
  standalone: true,
  imports: [
    ClrTabsModule,
    ClrDatagridModule,
    ClrIconModule,
    TranslocoDirective,
    CommentOverviewComponent
  ],
  templateUrl: './comment-project-card.component.html',
  styleUrl: './comment-project-card.component.sass'
})
export class CommentProjectCardComponent {
  loading: boolean = true;
  devMode: boolean = false;

  @Input() projectId: string = 'null';
  /** 0 = no filter (project view); the dashboard passes the logged-in staff. */
  @Input() staffId: number = 0;

  constructor() {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(exclamationCircleIcon, exclamationTriangleIcon);
  }
}
